import PropTypes from 'prop-types'
import { useContext } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LoginContext } from './context/loginContext'
import AdminEBPRoutes from './rutas/AdminEBPRoutes'
import CompradorRoutes from './rutas/CompradorRoutes'
import ComunesRoutes from './rutas/ComunesRoutes'
import PublicRoutes from './rutas/PublicRoutes'
import VendedorRoutes from './rutas/VendedorRoutes'

const ContenedorPrincipal = (props) => {
  const { isAuthenticated } = useContext(LoginContext)

  return (
    <Routes>
      {PublicRoutes(props)}
      {ComunesRoutes(props)}
      {CompradorRoutes(props)}
      {VendedorRoutes(props)}
      {AdminEBPRoutes(props)}
      <Route
        path="*"
        element={<Navigate to={isAuthenticated ? '/Publicaciones' : '/'} replace />}
      />
    </Routes>
  )
}

ContenedorPrincipal.propTypes = {
  cambiarImagenPerfil: PropTypes.func.isRequired
}

export default ContenedorPrincipal
